import { Movement } from './../../movement/movement';
import { NavigationPlanMovementCreationDTO } from './navigation-plan-movement-creationDTO';

export class MovementQuestionaryAnswerDTO {
  questionnaireCode: string;
  answerCode: string;
}

export class MovementPlanByObjectiveCreateDTO {
  id?: number;
  customer: any;
  boat: any;
  sailor?: any;
  objectiveCode: string;
  questionnairesAnswer: MovementQuestionaryAnswerDTO[];
  executionDate: Date | string;
  returnTime?: Date | string;
  navigationPlan?: NavigationPlanMovementCreationDTO;
  movementLocationOrigin?: any;
  vacancyOrigin?: any;
  movementPrevision?:Movement[];
  observation?: string;

}
